import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasSelect", "label", "minWidth", "cellType"];
import React, { useMemo } from "react";
import MemoizedCell from "../components/MemoizedCell";
import { jsx as _jsx } from "react/jsx-runtime";
function useCells(columns, emptyPlaceholderText) {
  return useMemo(function () {
    return columns.map(function (_ref) {
      var hasSelect = _ref.hasSelect,
        label = _ref.label,
        minWidth = _ref.minWidth,
        cellType = _ref.cellType,
        restProps = _objectWithoutProperties(_ref, _excluded);
      return {
        renderCell: function renderCell(item) {
          return /*#__PURE__*/_jsx(MemoizedCell, {
            cellType: cellType,
            restProps: restProps,
            item: item,
            emptyPlaceholderText: emptyPlaceholderText
          });
        },
        key: restProps.colId
      };
    });
  }, [columns, emptyPlaceholderText]);
}
export default useCells;